import { render, staticRenderFns } from "./wyPropertys.vue?vue&type=template&id=5677298c&scoped=true&"
import script from "./wyPropertys.vue?vue&type=script&lang=js&"
export * from "./wyPropertys.vue?vue&type=script&lang=js&"
import style0 from "./wyPropertys.vue?vue&type=style&index=0&id=5677298c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677298c",
  null
  
)

export default component.exports